export const ROUTE = {
  HOME: '/',
  KICK_COUNTER: '/kick-counter',
  SUMMARY: '/summary',
};

export const COUNTER_MODE = {
  TIME: 'time',
  KICK: 'kick',
};

export const KICK_TYPE = {
  GENERAL: 'General',
  FLUTTER: 'Flutter',
  KICK: 'Kick',
  SWISH: 'Swish',
  ROLL: 'Roll',
};

export const KICK_STRENGTH = {
  VERY_LIGHT: 'Very Light',
  LIGHT: 'Light',
  MODERATE: 'Moderate',
  STRONG: 'Strong',
  VERY_STRONG: 'Very Strong',
};

export const MAX_TIME = 30 * 60;
export const MAX_KICK = 10;

export const TIME_WARN_1 = 10 * 60;
export const TIME_WARN_2 = 20 * 60;

export const IOS_DOWNLOAD_LINK = 'https://apple.co/3e2MVWC';
export const ANDROID_DOWNLOAD_LINK = 'https://bit.ly/3rn3iAo';
export const PRIVACY_POLICY_LINK = 'https://www.fluttercare.com/privacy-policy';
export const TERMS_CONDITION_LINK = 'https://www.fluttercare.com/terms-and-conditions';
export const LICENSE_AGREEMENT_LINK = 'https://www.fluttercare.com/end-user-license-agreement';

export const APPLE_PROVIDER = 'apple.com';
